import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl, UpdateClaims } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const get_pending_content_houses = createAsyncThunk<any, any, any>(
  'auto/get/pending/content/houses',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/pending/content/houses'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const store_new_content_house = createAsyncThunk<any, any, any>(
  'auto/store/new/content/house',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/store/new/content/house'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const store_new_content_creator = createAsyncThunk<any, any, any>(
  'auto/store/new/content/creator',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/store/new/content/creator'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_content_creators = createAsyncThunk<any, any, any>(
  'auto/get/content/creators',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/content/creators'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_my_content_house_invitations = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/load/my/content/house/invitations',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/load/my/content/house/invitations'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const reject_invitation = createAsyncThunk<any, any, any>(
  'auto/reject/content/house/invitation',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/reject/content/house/invitation'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const accept_invitation = createAsyncThunk<any, any, any>(
  'auto/accept/content/house/invitation',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/accept/content/house/invitation'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }
        await UpdateClaims()
        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_existing_content_houses = createAsyncThunk<any, any, any>(
  'auto/get/content/house',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/content/house'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_content_houses = createAsyncThunk<any, any, any>(
  'auto/get/content/houses',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/content/houses'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_existing_content_houses_for_membership = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/load/existing/content/houses/for/membership',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/load/existing/content/houses/for/membership'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const toggle_admin_for_user = createAsyncThunk<any, any, any>(
  'auto/toggle/admin/for/user',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/toggle/admin/for/user'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const send_invitation_for_user = createAsyncThunk<any, any, any>(
  'auto/send/invitateion/for/user',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/send/invitateion/for/user'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const cancel_invitee_invitation = createAsyncThunk<any, any, any>(
  'auto/cancel/invitee/invitation',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/cancel/invitee/invitation'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_my_content_house_content_crerator = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/load/my/content/house/content/creator',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/load/my/content/house/content/creator'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const update_my_contenthouse_contentcreator_profile = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/update/my/contenthouse/contentcreator/profile',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/update/my/contenthouse/contentcreator/profile'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_my_content_houses = createAsyncThunk<any, any, any>(
  'auto/load/my/content/houses',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/load/my/content/houses'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const update_contenthouse_information = createAsyncThunk<any, any, any>(
  'auto/update/contenthouse/information',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/update/contenthouse/information'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
